import getSurfaceStore from '../store/store';
import refreshEventsCount from '../actions/refreshEventsCount';
import { orchestrator } from 'satcheljs';
import { setNavigationMode } from '../mutators/navigationModeMutators';
import { toggleNavigationMode } from '../actions/toggleNavigationMode';

/**
 * Mutator to toggle the navigation mode and update the events count map
 */
export const toggleNavigationModeOrchestrator = orchestrator(
    toggleNavigationMode,
    actionMessage => {
        const { navigationMode } = getSurfaceStore();
        const { newMode } = actionMessage;
        // No-op if there is no change in navigation mode
        if (navigationMode !== newMode) {
            setNavigationMode(actionMessage.newMode);
            refreshEventsCount();
        }
    }
);
